import { getFeature } from 'Cloud/Application/FeaturesEs6';

/**
 * @see https://jira.vk.team/browse/CLOUDWEB-18137 Просмотр ВК файлов в R7
 */
export const R7_EMBEDDED = getFeature('r7-embedded') || false;
